
import { z } from "zod";

export const EscalationStageValues = ["NOT_CONTACTED", "PENDING_CONTACT", "PENDING_RESOLUTION", "RESOLVED_PENDING_COMPLETION", "COMPLETION", "DISMISSED"] as const;
export const EscalationStageSchema = z.enum(EscalationStageValues);
export const EscalationStage = EscalationStageSchema.enum;
export type EscalationStage = (typeof EscalationStageValues)[number];
